import React, { useEffect } from 'react'
import { makeAutoObservable } from 'mobx'
import { observer } from 'mobx-react-lite'
import { MDBBtn } from 'mdb-react-ui-kit'

import CalendarEventService from './../../../../shared/services/CalendarEvent.service'

import moment from 'moment'

import './AddToCalendarButtons.component.scss'

const getEventDetail = async eventId => {
  try {
    return (await CalendarEventService.detail(eventId)).eventDetail
  } catch (ex) {
    return false
  }
}

function convertHtmlForIcs(html) {
  var output = ''

  if (html && typeof html === 'string') {
    try {
      const div = document.createElement('div')
      // div.innerHTML = html.replace(/<br\s*[\/]?>/gi, '\n');
      div.innerHTML = html.replace(/<br\s*[/]?>/gi, '                                                         ')
      html = div.textContent || div.innerText || ''
    } catch (ex) {
      console.log('FAILED html conversion for ICS:  ' + ex)
    }

    for (var i = 0; i < html.length; i++) {
      if (html.charCodeAt(i) <= 127) {
        output += html.charAt(i)
      }
    }
  }

  return output
}

const GOOGLE_CAL =
    'https://calendar.google.com/calendar/render?action=TEMPLATE&dates={startUtcZ}Z%2F{endUtcZ}Z&details={eventBody}&location={eventLocation}&text={eventTitle}',
  OUTLOOK =
    'https://outlook.live.com/calendar/0/deeplink/compose?allday=false&enddt={endUtcIso}&location={eventLocation}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt={startUtcIso}&subject={eventTitle}&body={eventBody}',
  OFFICE_365 =
    'https://outlook.office.com/calendar/0/action/compose?allday=false&enddt={endUtcIso}&location={eventLocation}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt={startUtcIso}&subject={eventTitle}&body={eventBody}',
  YAHOO =
    'https://calendar.yahoo.com/?desc={eventBody}&dur=&et={endUtcZ}Z&in_loc={eventLocation}&st={startUtcZ}Z&title={eventTitle}&v=60'

const DOWNLOAD_ICON = (
    <span className='svg-icon-wrapper'>
      <svg xmlns='http://www.w3.org/2000/svg' width='30.7' height='28.715' viewBox='0 0 30.7 28.715'>
        <path
          d='M14.86,20.3a7.42,7.42,0,1,1,7.434,7.414h-.021A7.381,7.381,0,0,1,14.86,20.3Zm1.968-.059a5.45,5.45,0,1,0,5.513-5.392h-.051A5.47,5.47,0,0,0,16.827,20.236Zm-13.9,6.485A2.922,2.922,0,0,1,.164,24.689,3.178,3.178,0,0,1,0,23.665Q.005,14.833,0,6A3.011,3.011,0,0,1,2.709,2.973c.191-.025.277.025.269.244-.017.474-.008.948,0,1.423A2.364,2.364,0,0,0,4.3,6.84a2.334,2.334,0,0,0,2.586-.172A2.353,2.353,0,0,0,7.922,4.673c0-.485.006-.969,0-1.454,0-.177.029-.256.233-.254q1.253.017,2.506,0c.2,0,.242.067.238.25-.011.474-.006.948,0,1.423a2.368,2.368,0,0,0,1.322,2.2A2.336,2.336,0,0,0,14.8,6.669a2.354,2.354,0,0,0,1.04-1.994c0-.485.01-.97,0-1.454-.007-.21.067-.257.264-.255q1.236.014,2.474,0c.2,0,.244.063.239.248-.011.474-.006.949,0,1.423a2.37,2.37,0,0,0,1.322,2.2,2.336,2.336,0,0,0,2.586-.17,2.358,2.358,0,0,0,1.042-1.994c0-.485.01-.969,0-1.453-.007-.209.061-.277.262-.25A3.012,3.012,0,0,1,26.73,6q.005,3.2,0,6.4v.272a10.009,10.009,0,0,0-1.536-.684.514.514,0,0,1-.452-.642c.036-.409,0-.824.011-1.237,0-.159-.045-.233-.21-.211a1.173,1.173,0,0,1-.154,0q-11.012,0-22.025-.007c-.3,0-.392.059-.391.381q.018,6.682,0,13.363a1.093,1.093,0,0,0,1.134,1.122c2.318-.014,4.637-.014,6.956-.013q2.12,0,4.242,0a.55.55,0,0,1,.566.291,9.427,9.427,0,0,0,1.306,1.637c-.008.071-.048.056-.074.056q-3.571,0-7.141,0Q5.944,26.732,2.926,26.721ZM19.7,23.047a.386.386,0,0,1,.019-.536c.472-.581.941-1.164,1.426-1.732a.975.975,0,0,0,.255-.547c.071-.795.124-1.591.194-2.385.048-.548.117-1.1.175-1.643.028-.273.212-.35.449-.365a.472.472,0,0,1,.554.327,4.308,4.308,0,0,1,.1.912c.1.8.136,1.609.2,2.415.037.427.091.853.138,1.28a.926.926,0,0,1-.439.859c-.715.514-1.41,1.056-2.109,1.591a.705.705,0,0,1-.417.178C20.053,23.4,19.894,23.248,19.7,23.047Zm-7.821-.279c-.484,0-.968,0-1.451,0a.474.474,0,0,1-.529-.534q-.006-.957,0-1.914a.467.467,0,0,1,.512-.519q1.467-.008,2.933,0a.468.468,0,0,1,.513.519q.008.956,0,1.913a.474.474,0,0,1-.527.536l-.558,0Zm-7.386,0a.476.476,0,0,1-.533-.531c0-.637,0-1.276,0-1.913A.474.474,0,0,1,4.5,19.8q1.435-.005,2.87,0a.48.48,0,0,1,.548.546q.005.941,0,1.883c0,.366-.181.537-.555.54-.473,0-.946,0-1.419,0H5.054Zm5.919-3.961a.467.467,0,0,1-.512-.519q-.008-.957,0-1.914a.474.474,0,0,1,.529-.534c.493,0,.987,0,1.481,0,.474,0,.946,0,1.42,0a.474.474,0,0,1,.527.535q.006.957,0,1.914a.467.467,0,0,1-.513.518q-.733,0-1.466,0T10.415,18.807Zm-5.938,0a.467.467,0,0,1-.513-.518c-.005-.638,0-1.276,0-1.914a.474.474,0,0,1,.528-.535c.484,0,.967,0,1.451,0s.968,0,1.451,0a.475.475,0,0,1,.529.534c0,.638,0,1.276,0,1.914a.467.467,0,0,1-.512.519q-.733,0-1.466,0T4.477,18.807Zm5.984-3.958c-.387,0-.557-.176-.559-.568,0-.617,0-1.234,0-1.852a.48.48,0,0,1,.545-.548q1.435,0,2.871,0c.368,0,.541.179.542.552,0,.627,0,1.255,0,1.883a.474.474,0,0,1-.53.533c-.311,0-.622,0-.933,0H10.461Zm-5.962,0a.474.474,0,0,1-.536-.527q-.006-.957,0-1.914A.474.474,0,0,1,4.5,11.88c.484,0,.967,0,1.451,0s.946,0,1.42,0a.481.481,0,0,1,.551.543q.005.942,0,1.883a.48.48,0,0,1-.552.542l-1.536,0Zm11.344-2.437c0-.314.162-.525.441-.527,1.157-.01,2.314,0,3.482.025a9.04,9.04,0,0,0-3.923,2.548C15.842,13.709,15.839,13.059,15.843,12.411Zm5.342-6.472A1.525,1.525,0,0,1,19.8,4.49q-.019-1.515,0-3.029a1.483,1.483,0,0,1,2.966.019c.007.495,0,.99,0,1.6a10.515,10.515,0,0,1-.06,1.726,1.5,1.5,0,0,1-1.417,1.135C21.257,5.943,21.221,5.942,21.184,5.939Zm-15.739,0A1.523,1.523,0,0,1,3.964,4.467c-.008-.505,0-1.009,0-1.631a11.164,11.164,0,0,1,.059-1.7A1.477,1.477,0,0,1,5.573.005,1.509,1.509,0,0,1,6.928,1.441c.014,1.02.016,2.041,0,3.06A1.512,1.512,0,0,1,5.447,5.939Zm7.8-.005A1.509,1.509,0,0,1,11.886,4.5q-.022-1.529,0-3.06a1.482,1.482,0,0,1,2.964.032c.008.5,0,1.009,0,1.634A11.259,11.259,0,0,1,14.793,4.8a1.478,1.478,0,0,1-1.434,1.14C13.32,5.939,13.282,5.938,13.243,5.934Z'
          transform='translate(0.5 0.506)'
          stroke='rgba(0,0,0,0)'
          strokeMiterlimit='10'
          strokeWidth='1'
        />
      </svg>
    </span>
  ),
  GOOGLE_ICON = (
    <span className='svg-icon-wrapper'>
      <svg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M25.5 10.5L18.75 9.75L10.5 10.5L9.75 18L10.5 25.5L18 26.4375L25.5 25.5L26.25 17.8125L25.5 10.5Z'
          fill='white'
        />
        <path
          d='M13.5769 22.1362C13.0163 21.7574 12.6281 21.2043 12.4163 20.4731L13.7175 19.9368C13.8356 20.3868 14.0419 20.7356 14.3363 20.9831C14.6288 21.2306 14.985 21.3524 15.4013 21.3524C15.8269 21.3524 16.1925 21.2231 16.4981 20.9643C16.8038 20.7056 16.9575 20.3756 16.9575 19.9762C16.9575 19.5675 16.7963 19.2337 16.4738 18.9749C16.1513 18.7162 15.7463 18.5868 15.2625 18.5868H14.5106V17.2987H15.1856C15.6019 17.2987 15.9525 17.1862 16.2375 16.9612C16.5225 16.7362 16.665 16.4287 16.665 16.0368C16.665 15.6881 16.5375 15.4106 16.2825 15.2025C16.0275 14.9943 15.705 14.8893 15.3131 14.8893C14.9306 14.8893 14.6269 14.9906 14.4019 15.195C14.1769 15.3993 14.0138 15.6506 13.9106 15.9468L12.6225 15.4106C12.7931 14.9268 13.1063 14.4993 13.5656 14.13C14.025 13.7606 14.6119 13.575 15.3244 13.575C15.8513 13.575 16.3256 13.6762 16.7456 13.8806C17.1656 14.085 17.4956 14.3681 17.7338 14.7281C17.9719 15.09 18.09 15.495 18.09 15.945C18.09 16.4043 17.9794 16.7925 17.7581 17.1112C17.5369 17.43 17.265 17.6737 16.9425 17.8443V17.9212C17.3681 18.0993 17.715 18.3712 17.9888 18.7368C18.2606 19.1025 18.3975 19.5393 18.3975 20.0493C18.3975 20.5593 18.2681 21.015 18.0094 21.4143C17.7506 21.8137 17.3925 22.1287 16.9388 22.3574C16.4831 22.5862 15.9713 22.7025 15.4031 22.7025C14.745 22.7043 14.1375 22.5149 13.5769 22.1362Z'
          fill='#2684FC'
        />
        <path
          d='M21.5625 15.6787L20.1413 16.7118L19.4269 15.628L21.99 13.7793H22.9725V22.4999H21.5625V15.6787Z'
          fill='#2684FC'
        />
        <path d='M25.5 32.25L32.25 25.5V24H25.5V25.5H24V32.25H25.5Z' fill='#E94235' />
        <path d='M25.5 25.5H9V32.25H25.5V25.5Z' fill='#00AC47' />
        <path d='M6 3.75C4.75687 3.75 3.75 4.75687 3.75 6V27H10.5V10.5H27V3.75H6Z' fill='#2684FC' />
        <path d='M3.75 25.5V30C3.75 31.2431 4.75687 32.25 6 32.25H10.5V25.5H3.75Z' fill='#00832D' />
        <path d='M32.25 9H25.5V25.5H32.25V9Z' fill='#FFBA00' />
        <path d='M32.25 10.5V6C32.25 4.75687 31.2431 3.75 30 3.75H25.5V10.5H32.25Z' fill='#0066DA' />
      </svg>
    </span>
  ),
  OFFICE_365_ICON = (
    <span className='svg-icon-wrapper'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='103.17322'
        height='104.31332'
        viewBox='0 0 103.17322 104.31332'
        fill='none'
      >
        <path
          d='m 64.566509,22.116383 v 20.404273 l 7.130526,4.489881 c 0.188058,0.05485 0.595516,0.05877 0.783574,0 L 103.16929,26.320259 c 0,-2.44867 -2.28412,-4.203876 -3.573094,-4.203876 H 64.566509 z'
          fill='#0072c6'
        />
        <path
          d='m 64.566509,50.13308 6.507584,4.470291 c 0.916782,0.673874 2.021622,0 2.021622,0 -1.100922,0.673874 30.077495,-20.035993 30.077495,-20.035993 v 37.501863 c 0,4.082422 -2.61322,5.794531 -5.551621,5.794531 H 64.562591 V 50.13308 z'
          fill='#0072c6'
        />
        <g transform='matrix(3.9178712,0,0,3.9178712,-13.481403,-41.384473)'>
          <path
            d='m 11.321,20.958 c -0.566,0 -1.017,0.266 -1.35,0.797 -0.333,0.531 -0.5,1.234 -0.5,2.109 0,0.888 0.167,1.59 0.5,2.106 0.333,0.517 0.77,0.774 1.31,0.774 0.557,0 0.999,-0.251 1.325,-0.753 0.326,-0.502 0.49,-1.199 0.49,-2.09 0,-0.929 -0.158,-1.652 -0.475,-2.169 -0.317,-0.516 -0.75,-0.774 -1.3,-0.774 z'
            fill='#0072c6'
          />
          <path
            d='m 3.441,13.563 v 20.375 l 15.5,3.25 V 10.563 l -15.5,3 z m 10.372,13.632 c -0.655,0.862 -1.509,1.294 -2.563,1.294 -1.027,0 -1.863,-0.418 -2.51,-1.253 C 8.094,26.4 7.77,25.312 7.77,23.97 c 0,-1.417 0.328,-2.563 0.985,-3.438 0.657,-0.875 1.527,-1.313 2.61,-1.313 1.023,0 1.851,0.418 2.482,1.256 0.632,0.838 0.948,1.942 0.948,3.313 10e-4,1.409 -0.327,2.545 -0.982,3.407 z'
            fill='#0072c6'
          />
        </g>
      </svg>
    </span>
  )

const getCalIcs = evtDetail => {
  const _zpICS = function (s) {
      return ('0' + s).slice(-2)
    },
    _isofixICS = function (d) {
      var offset = ('0' + new Date().getTimezoneOffset() / 60).slice(-2)
      return typeof d == 'string'
        ? d.replace(/-/g, '') + 'T' + offset + '0000Z'
        : d.getFullYear() + _zpICS(d.getMonth() + 1) + _zpICS(d.getDate()) + 'T' + _zpICS(d.getHours()) + '0000Z'
    },
    _saveICS = function (fileURL) {
      const fileName = [
        `${(evtDetail?.summary + '')
          .trim()
          .replace(/ +/, '-')
          .replace(/[^A-Za-z0-9-]/g, '')
          .substr(24)}`,
        `${evtDetail?.start?.format('YYYY-MM-DD')}`,
        'ics',
      ].join('.')

      if (!window.ActiveXObject) {
        var save = document.createElement('a')
        save.href = fileURL
        save.target = '_blank'
        save.download = fileName

        var evt = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: false,
        })
        save.dispatchEvent(evt)
        ;(window.URL || window.webkitURL).revokeObjectURL(save.href)
      }

      // for IE < 11
      else if (!!window.ActiveXObject && document.execCommand) {
        var _window = window.open(fileURL, '_blank')
        _window.document.close()
        _window.document.execCommand('SaveAs', true, fileName || fileURL)
        _window.close()
      }
    }

  evtDetail.description = convertHtmlForIcs(evtDetail?.description)

  try {
    _saveICS(
      'data:text/calendar;base64,' +
        btoa(
          [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'METHOD:REQUEST',
            'BEGIN:VEVENT',
            'UID:event-' + new Date().getTime() + '@usabg-backoffice',
            'DTSTAMP:' + _isofixICS(new Date()),
            evtDetail?.start ? `DTSTART:${evtDetail?.start?.format('YYYYMMDDTHHmmss')}Z` : false,
            evtDetail?.end ? `DTEND:${evtDetail?.end?.format('YYYYMMDDTHHmmss')}Z` : false,
            evtDetail?.description
              ? `DESCRIPTION:${evtDetail.description}`.replace(/[\u0250-\ue007]|<(\/)?html-blob>/g, '')
              : false,
            evtDetail?.summary
              ? `SUMMARY:${evtDetail.summary}`.replace(/[\u0250-\ue007]|<(\/)?html-blob>/g, '')
              : false,
            evtDetail?.location
              ? `LOCATION:${evtDetail.location}`.replace(/[\u0250-\ue007]|<(\/)?html-blob>/g, '')
              : false,
            'LAST-MODIFIED:' + _isofixICS(new Date()),
            'SEQUENCE:0',
            'END:VEVENT',
            'END:VCALENDAR',
          ]
            .filter(n => n)
            .join('\r\n')
        )
    )
    return true
  } catch (e) {
    console.log(e)
    return false
  }
}

const getCalUrl = (calendar, evtDetail) => {
  const calParams = {
    eventTitle: '',
    eventBody: '',
    eventLocation: '',
  }

  if (evtDetail?.summary)
    calParams.eventTitle = encodeURI(evtDetail.summary.replace(/[\u0250-\ue007]|<(\/)?html-blob>/g, ''))
      .replace(/:/g, '%3A')
      .replace(/\?/g, '%3F')
      .replace(/!/g, '%21')
      .replace(/&/g, '%26')
      .replace(/\+/g, '%2B')
      .replace(/,/g, '%2C')
  if (evtDetail?.start) calParams.startUtcZ = evtDetail.start.format('YYYYMMDDTHHmmss')
  if (evtDetail?.end) calParams.endUtcZ = evtDetail.end.format('YYYYMMDDTHHmmss')
  if (evtDetail?.start) calParams.startUtcIso = evtDetail.start.format('YYYY-MM-DDTHH:mm:ss+00:00')
  if (evtDetail?.end) calParams.endUtcIso = evtDetail.end.format('YYYY-MM-DDTHH:mm:ss+00:00')
  if (evtDetail?.description)
    calParams.eventBody = encodeURI(evtDetail.description.replace(/[\u0250-\ue007]|<(\/)?html-blob>/g, ''))
      .replace(/:/g, '%3A')
      .replace(/\?/g, '%3F')
      .replace(/!/g, '%21')
      .replace(/&/g, '%26')
      .replace(/\+/g, '%2B')
      .replace(/,/g, '%2C')
  if (evtDetail?.location) calParams.eventLocation = encodeURI(evtDetail.location)

  let url = null
  switch (calendar) {
    case 'google':
      url = GOOGLE_CAL
      break
    case 'outlook':
      url = OUTLOOK
      break
    case 'office365':
      url = OFFICE_365
      if (calParams?.startUtcZ)
        calParams.startUtcZ = escape(calParams.startUtcZ).replace(/#/g, '%23').replace(/\+/g, '%2B')
      if (calParams?.endUtcZ) calParams.endUtcZ = escape(calParams.endUtcZ).replace(/#/g, '%23').replace(/\+/g, '%2B')
      if (calParams?.startUtcIso)
        calParams.startUtcIso = escape(calParams.startUtcIso).replace(/#/g, '%23').replace(/\+/g, '%2B')
      if (calParams?.endUtcIso)
        calParams.endUtcIso = escape(calParams.endUtcIso).replace(/#/g, '%23').replace(/\+/g, '%2B')
      break
    case 'yahoo':
      url = YAHOO
      break
    default:
      return
  }

  Object.keys(calParams).forEach(key => (url = url.replace(`{${key}}`, calParams[key])))

  // Additional chars to be escaped, if necc.
  // url = url
  // .replace(/:/g, '%3A')
  // .replace(/\//g, '%2F')
  // .replace(/\?/g, '%3F')
  // .replace(/#/g, '%23')
  // .replace(/\[/g, '%5B')
  // .replace(/\]/g, '%5D')
  // .replace(/@/g, '%40')
  // .replace(/!/g, '%21')
  // .replace(/\$/g, '%24')
  // .replace(/&/g, '%26')
  // .replace(/'/g, '%27')
  // .replace(/\(/g, '%28')
  // .replace(/\)/g, '%29')
  // .replace(/\*/g, '%2A')
  // .replace(/\+/g, '%2B')
  // .replace(/,/g, '%2C')
  // .replace(/;/g, '%3B')
  // .replace(/=/g, '%3D')
  // .replace(/%/g, '%25')

  return url.replace(/#/g, '%23')
}

class EventDetailStore {
  isLoading = false
  eventId = null
  evtDetail = null
  urls = {
    google: null,
    office: null,
    outlook: null,
    yahoo: null,
  }

  constructor() {
    makeAutoObservable(this)
  }

  setEventDetail = async eventId => {
    this.evtDetail = {}

    const evtDetail = await getEventDetail(eventId)
    if (evtDetail) {
      if (evtDetail?.location && typeof evtDetail.location === 'object')
        evtDetail.location = evtDetail.location?.address
          ? typeof evtDetail.location.address === 'object'
            ? Object.values(evtDetail.location.address).join(' ')
            : evtDetail.location.address
            ? `${evtDetail.location.address}`
            : ''
          : ''

      if (evtDetail?.body && typeof evtDetail.body === 'object')
        evtDetail.description = evtDetail.body?.content ? evtDetail.body.content : ''

      this.evtDetail.summary = evtDetail.summary
      this.evtDetail.description = evtDetail.description || ''
      this.evtDetail.location = evtDetail?.location

      this.evtDetail.start = moment.tz(evtDetail.start.dateTime, evtDetail.start.timeZone).utc()
      this.evtDetail.end = moment.tz(evtDetail.end.dateTime, evtDetail.end.timeZone).utc()
    }

    return true
  }

  getDetail = async (eventId, onCanAdd) => {
    if (this.eventId === eventId) return true

    let canAdd = false
    this.isLoading = true
    this.eventId = eventId

    canAdd = await this.setEventDetail(eventId)

    this.isLoading = false
    if (onCanAdd && typeof onCanAdd === 'function') onCanAdd(canAdd)
  }
}

const Store = new EventDetailStore()

const AddToCalendarButtons = ({ eventId, onCanAdd }) => {
  const addToCal = calendar => {
    try {
      window.open(getCalUrl(calendar, Store.evtDetail), '_BLANK')
    } catch (ex) {
      console.error(`Error attempting to open calendar event sync link. ${ex}`)
    }
  }

  const downloadToCal = () => {
    try {
      getCalIcs(Store.evtDetail)
    } catch (ex) {
      console.error(`Error attempting to open calendar event sync link. ${ex}`)
    }
  }

  const renderButtons = () => {
    if (Store.isLoading)
      return (
        <span>
          <i className='fa fa-spin fa-spinner' />
        </span>
      )

    return (
      <>
        <MDBBtn
          type='button'
          color='default'
          className='add-cal-btn cal-btn-office365'
          onClick={() => addToCal('office365')}
        >
          <div>{OFFICE_365_ICON}</div>
          <div>
            Office 365
            <br />
            Event
          </div>
        </MDBBtn>
        <MDBBtn type='button' color='default' className='add-cal-btn cal-btn-google' onClick={() => addToCal('google')}>
          <div>{GOOGLE_ICON}</div>
          <div>
            Google
            <br />
            Event
          </div>
        </MDBBtn>
        {/*<MDBBtn type='button' color='default' className='add-cal-btn cal-btn-outlook' onClick={() => addToCal('outlook')}>Outlook</MDBBtn>*/}
        {/*<MDBBtn type='button' color='default' className='add-cal-btn cal-btn-yahoo' onClick={() => addToCal('yahoo')}>Yahoo</MDBBtn>*/}
        <MDBBtn type='button' color='default' className='add-cal-btn cal-btn-ics' onClick={() => downloadToCal()}>
          <div>{DOWNLOAD_ICON}</div>
          <div>
            Download
            <br />
            Event
          </div>
        </MDBBtn>
      </>
    )
  }

  useEffect(() => {
    if (eventId) Store.getDetail(eventId, onCanAdd)
  }, [eventId, onCanAdd])

  return <div id='AddToCalendarButtonsComponent'>{renderButtons()}</div>
}

export default observer(AddToCalendarButtons)
